export interface User {
  id: number;
  representee_id: number;
  first_name: string;
  last_name: string;
  organisation_name: string;
  email_address: string;
  relation_type: RelationType;
}

export enum RelationType {
  contact = "contact",
  private = "private",
}

export interface StateInterface {
  loggedIn: boolean;
  postLoginUrl: string;
  profile: User;
}
